<div class="top-bar-container card-bg box-shadow">
  <div class="top-bar" *ngIf="currentScreen$ | async as currentScreen">
    <div
      class="nav-btn"
      [class.active]="currentScreen === 'calendar'"
      (click)="onCalendarClick()"
    >
      <mat-icon class="nav-icon">calendar_month</mat-icon>
      <div class="nav-label">Calendar</div>
    </div>
    <div
      class="nav-btn"
      [class.active]="currentScreen === 'sequence'"
      (click)="onSequenceClick()"
    >
      <mat-icon class="nav-icon">event_note</mat-icon>
      <mat-icon class="nav-icon arrow-left" *ngIf="currentScreen === 'flight'"
        >arrow_left</mat-icon
      >
      <mat-icon
        class="nav-icon arrow-right"
        *ngIf="currentScreen === 'calendar' || currentScreen === 'search'"
        >arrow_right</mat-icon
      >
      <!-- <mat-icon class="nav-icon">event_note</mat-icon> -->
      <div class="nav-label">{{ getSequenceLabel() }}</div>
    </div>
    <div
      class="nav-btn"
      [class.active]="currentScreen === 'flight'"
      (click)="onFlightClick()"
    >
      <mat-icon class="nav-icon">flight</mat-icon>
      <mat-icon class="nav-icon arrow-right" *ngIf="currentScreen !== 'flight'"
        >arrow_right</mat-icon
      >
      <div class="nav-label">{{ getFlightLabel() }}</div>
    </div>
    <div
      class="nav-btn"
      [class.active]="currentScreen === 'search'"
      (click)="onSearchClick()"
    >
      <mat-icon class="nav-icon">search</mat-icon>
      <div class="nav-label">Flt Search</div>
    </div>
  </div>
</div>
